<template>
  <div class="new_vip">
    <div class="title_line">
      <el-page-header @back="goBack" content="交班"></el-page-header>
    </div>
    <div class="content" v-loading="loading">
      <div class="options">
        <div class="time_options" style="display: flex; align-items: center;">
          <!-- 交接时间：
          <el-date-picker
            v-model="timeValue"
            type="datetimerange"
            range-separator="-"
            size="small"
            style="width: 300px;margin-right: 10px;"
            format="yyyy-MM-dd HH:mm">
          </el-date-picker>
          白班 -->
          <span style="margin-right: 10px;">门店</span>
          <el-select
            v-model="room_id"
            size="small"
            style="margin-right: 5px;"
            :disabled="allRoom"
          >
            <el-option
              v-for="item in roomList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <div
            style="width: 200px; height: 40px;"
            v-if="false"
            @click="num++"
          ></div>
          <!-- <el-checkbox v-model="allRoom" style="margin-right:15px;">全部门店</el-checkbox> -->
          <!-- 日期：{{newDate}} -->
          <div v-if="duty_custom==1">
<span style="margin: 0 10px;">自定义交班时间</span>
          <el-date-picker
            v-model="dateValue[0]"
            type="date"
            class="date_picker_box"
            placeholder="开始日期"
            size="small"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-time-picker
            placeholder="时间"
            v-model="timeValue[0]"
            class="time_picker_box"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            size="small"
          ></el-time-picker>
          <span style="margin-right: 8px;">至</span>
          <el-date-picker
            v-model="dateValue[1]"
            type="date"
            class="date_picker_box"
            placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-time-picker
            placeholder="时间"
            v-model="timeValue[1]"
            class="time_picker_box"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            size="small"
          ></el-time-picker>
          </div>
          
        </div>
        <div style="width: 200px; height: 50px;" @click="showClick"></div>
        <div class="button_options">
          <el-button
            size="small"
            v-if="isShowJiaoBan == 1"
            @click="historyList()"
          >
            交班记录
          </el-button>
          <el-button size="small">打印</el-button>
          <el-button size="small">导出</el-button>
        </div>
      </div>
      <div class="emp_table">
        <div class="table_options">
          <div class="table_title">已交班员工：</div>
        </div>
        <el-table :data="doneList" size="small" :header-cell-style="setHeader">
          <el-table-column
            label="交班人"
            prop="employee.name"
          ></el-table-column>
          <el-table-column label="新增会员" prop="up_users"></el-table-column>
          <!-- <el-table-column label="售卡金额" prop="sale_card_amount"></el-table-column> -->
          <!-- <el-table-column label="充值总额" prop="charge_amount"></el-table-column> -->
          <el-table-column
            label="消费总额"
            prop="total_amount"
          ></el-table-column>
          <!-- <el-table-column label="总积分" prop="total_point"></el-table-column> -->
          <el-table-column label="现金收入" prop="cash"></el-table-column>
          <el-table-column label="余额收入" prop="balance"></el-table-column>
          <!-- <el-table-column label="微信收入" prop="total_wechat"></el-table-column>
          <el-table-column label="支付宝收入" prop="total_alipay"></el-table-column> -->
          <el-table-column label="银联收入" prop="unionpay"></el-table-column>
          <el-table-column label="门店名称" prop="room.name"></el-table-column>
          <el-table-column
            label="交接时间"
            prop="end_time"
            width="136px"
          ></el-table-column>
          <el-table-column label="详细信息" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="employeeDetail(scope.row)">
                详细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="emp_table">
        <div class="table_options">
          <div class="table_title">未交班员工：</div>
          <div>
            <span v-if="Isshow">
              <!-- <el-button type="primary" size="small" class="table_button" @click="forEmp()">员工交班</el-button> -->
              <span v-if="!showDateInput">
                <span v-if="settleDate.start && settleDate.end">
                  <span>银行卡入账时间：</span>
                  <span>{{ settleDate.start }}至{{ settleDate.end }}</span>
                </span>
              </span>
              <span v-else>
                <span>银行卡入账时间：</span>
                <!--              <el-time-picker-->
                <!--                size="small"-->
                <!--                v-model="settleDateTime"-->
                <!--                placeholder="入账时间点"-->
                <!--                value-format="HH:mm:ss"-->
                <!--                @change="editTime"-->
                <!--              >-->
                <!--              </el-time-picker>-->
                <el-time-select
                  v-model="settleDateTime"
                  :picker-options="{
                    start: '00:00',
                    step: '01:00',
                    end: '23:00',
                  }"
                  value-format="HH:mm:ss"
                  placeholder="入账时间"
                  @change="editTime"
                ></el-time-select>
              </span>

              <el-button
                style="margin-left: 5px;"
                type="primary"
                size="small"
                @click="editsettletime()"
              >
                编辑入账时间
              </el-button>
            </span>

            <el-button
              style="margin-left: 30px;"
              type="primary"
              size="small"
              @click="changeButton()"
            >
              交班
            </el-button>
          </div>
        </div>
        <el-table
          :data="undoneList"
          size="small"
          :header-cell-style="setHeader"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55px;"></el-table-column>
          <el-table-column
            label="员工名称"
            prop="employee.name"
          ></el-table-column>
          <el-table-column label="新增会员" prop="up_users"></el-table-column>
          <el-table-column
            label="消费总额"
            prop="total_amount"
          ></el-table-column>
          <el-table-column label="总积分" prop="total_point"></el-table-column>
          <el-table-column label="现金收入" prop="total_cash"></el-table-column>
          <el-table-column
            label="余额收入"
            prop="total_balance"
          ></el-table-column>
          <el-table-column label="银联收入" prop="total_bank"></el-table-column>
          <el-table-column label="详细信息" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="employeeDetail(scope.row.id)">
                详细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom_button" v-if="false">
        <!-- <el-button type="info" v-if="disableUsed" disabled>交班</el-button> -->
        <el-button type="primary" @click="changeButton()">交班</el-button>
        <!-- <div v-if="disableUsed" class="button_info">不可用原因：有未交班的员工。</div> -->
      </div>
    </div>
    <el-dialog
      :visible.sync="showEmployeeDetail"
      @close="showEmployeeDetail = false"
    >
      <Stat :statData="employeeDetailData"></Stat>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  changeDutyData,
  changeDutyForEmp,
  editsettletimeDetail,
  saveSettletime,
  settletime,
} from '@/api/vip'
import { storeSelect } from '@/api/employee'
import Stat from '@/components/vip/changeDutyStat'
import {privacy} from '@/api/set'
// import History from "@/components/vip/changeDutyList"
export default {
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  data() {
    return {
      duty_custom:1,
      Isshow: false,
      loading: false, //页面loading
      timeValue: [], //当前交班时间段
      doneList: [], //已交班员工
      undoneList: [], //未交班员工
      disableUsed: false, //管理员交班按钮 true:不可用 false:可用
      showEmployeeDetail: false, //显示员工详细
      employeeDetailData: {}, //员工详细
      headerStyle: {
        //表头样式
        background: 'rgba(250,250,250,1)',
        color: '#000000',
      },
      roomList: [], //门店id
      room_id: '', //当前选择的门店
      newDate: '', //当前日期
      // showHistory: false, //交班记录
      // history_id: "", //交班记录门店id
      settelment_ids: '', //给员工交班id
      dateValue: [], //日期
      timeValue: [], //时间
      button_disable: false, //是否禁用
      allRoom: false, // 全选门店
      settleDate: {},
      showDateInput: false,
      settleDateTime: '',
      isShowJiaoBan: 1,
    }
  },
  watch: {
    // num(val) {
    //   if (val == 6) {
    //     this.showPswdialogVisible = true
    //   }
    // },
  },
  mounted() {
    this.init()
    this.getshowButton()
  },
  methods: {
    showClick() {
      this.num++
      if (this.num == 6) {
        this.showPswdialogVisible = true
      }
    },
    clocan() {
      this.psw = ''
      this.num = 0
      this.showPswdialogVisible = false
    },
    //保存时间
    editTime(e) {
      if (e) {
        let time = e + ':00'
        console.log('222333', time)
        saveSettletime({ app_id: this.app_id, settle_time: time }).then(
          (res) => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.showDateInput = false
              this.getsettletime()
            } else {
              this.$message.error(res.msg)
            }
          },
        )
      }
    },
    //显示时间输入框
    editsettletime() {
      this.showDateInput = true
      editsettletimeDetail({ app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          this.settleDateTime = res.data.settle_time
          console.log(res.data)
        } else {
          this.$message(res.msg)
        }
      })
    },
    //结算时间
    getsettletime() {
      settletime({ app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          this.Isshow = true
          this.settleDate = res.data
        }
      })
    },
    setHeader({ rowIndex }) {
      // 设置表头颜色
      if (rowIndex === 0) {
        return this.headerStyle
      } else {
        return ''
      }
    },
    async getshowButton() {
      const res = await privacy({ app_id: this.app_id })
      if (res.code == 200) {
        if (res.data.duty_logs==0||res.data.duty_logs==1) {
          this.isShowJiaoBan = res.data.duty_logs
          console.log(this.isShowJiaoBan)
        }
        this.duty_custom = res.data.duty_custom==0?0:1
      }
    },
    init() {
      // 当前交班信息
      this.loading = true
      var y = new Date().getFullYear()
      var m = new Date().getMonth() + 1
      var d = new Date().getDate()
      this.newDate = y + '-' + m + '-' + d
      var data = {
        token: this.token,
        app_id: this.app_id,
      }
      storeSelect(data).then((res) => {
        if (res.code == 200) {
          this.roomList = res.data
          this.roomList.unshift({ id: '0', name: '全部门店' })
          this.room_id = this.roomList[0].id
        } else {
          this.roomList = []
        }
      })
      this.getData()
      this.getsettletime()
    },
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      }
      changeDutyData(data).then((res) => {
        if (res.code == 200) {
          console.log(res.result)
          this.doneList = res.result
          this.undoneList = res.untask
          if (this.undoneList.length) {
            this.disableUsed = true
          } else {
            this.disableUsed = false
          }
        } else {
          this.button_disable = true
          this.$message({
            type: 'error',
            message: res.msg,
          })
        }
        this.loading = false
      })
    },
    employeeDetail(row) {
      //交班员工详细
      console.log(row)
      this.employeeDetailData = row
      this.showEmployeeDetail = true
    },
    changeButton() {
      //进入交班详情
      if (this.dateValue.length != 0) {
      }
      var v = localStorage.getItem('changeDutyVersion')
      var roomIds = this.room_id
      // if(this.allRoom){
      //   roomIds = "0"
      // }
      if (this.dateValue.length == 2 && this.timeValue.length == 2) {
        var start = this.dateValue[0] + ' ' + this.timeValue[0]
        var end = this.dateValue[1] + ' ' + this.timeValue[1]
        if (v == 2) {
          this.$router.push({
            path: 'changeDutyNew2',
            query: { roomid: roomIds, time: [start, end] },
          })
        } else {
          this.$router.push({
            path: 'changeDutyNew',
            query: { roomid: roomIds, time: [start, end] },
          })
        }
      } else {
        // this.$message("请选择日期时间")
        if (v == 2) {
          this.$router.push({
            path: 'changeDutyNew2',
            query: { roomid: roomIds },
          })
        } else {
          this.$router.push({
            path: 'changeDutyNew',
            query: { roomid: roomIds },
          })
        }
      }
    },
    historyList() {
      //交班记录
      this.$router.push({
        path: 'changeDutyList',
        query: { roomid: this.room_id },
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    // 表格多选
    handleSelectionChange(val) {
      this.settelment_ids = val == [] ? '' : val.map((x) => x.id).join(',')
      console.log(this.settelment_ids)
    },
    // 给员工交班
    forEmp() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: this.settelment_ids,
      }
      changeDutyForEmp(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '交班成功',
          })
          this.getData()
        } else {
          this.$message(res.msg)
        }
      })
    },
  },
  components: {
    Stat,
    History,
  },
}
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .title_line {
    height: 34px;
  }
  .content {
    background: #fff;
    height: 100%;
    padding: 15px;
    overflow: auto;
    .options {
      height: 50px;
      line-height: 50px;
      display: flex;
      .time_options {
        flex: 1;
      }
      .button_options {
        margin-right: 10px;
      }
      .date_picker_box {
        width: 130px;
      }
      .time_picker_box {
        width: 115px;
        margin-right: 8px;
      }
    }
    .emp_table {
      margin-top: 15px;
      margin-bottom: 50px;
      .table_options {
        display: flex;
        height: 50px;
        line-height: 50px;
        .table_title {
          flex: 1;
        }
        .table_button {
          margin-right: 10px;
        }
      }
    }
    .bottom_button {
      text-align: right;
      .button_info {
        margin-top: 5px;
        color: #999;
      }
    }
  }
}
</style>
